// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section .main_wrap[data-v-42ba7bd7]{position:relative;width:100%;overflow:hidden}@media screen and (max-width:500px){.section .main_wrap[data-v-42ba7bd7]{height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}}.section .main_wrap img[data-v-42ba7bd7]{width:100%}", ""]);
// Exports
module.exports = exports;
